import React from "react";
import "./stylesheets/About.css";
import dev from "../assets/dev.webp";

const About = () => {
  return (
    <div id="about">
      <div>
        <h1>
          All <span style={{ color: "#dc143c" }}>About</span> Me And My{" "}
          <span style={{ color: "#dc143c" }}>Experience</span>
        </h1>
        <div id="aboutChild">
          <div data-aos="zoom-in">
            <img src={dev} alt="" />
          </div>
          <div data-aos="zoom-in">
            <ul>
              <li>
                A self-motivated, team player with strong individual and
                interpersonal skills, who can easily adapt in any condition with
                a strong will to take challenges. Skilled with MERN stack in web
                development with 1 years. and 2 month of industry standards.
              </li>
              <br />
              <li>
                Fast-forwarding to today, as a Software Developer at Metapercept
                Technology Services, after dedicating significant time to
                preparation and displaying unwavering commitment, I have reached
                this significant milestone. Embarking on the next phase of
                career, I express great enthusiasm for learning, evolving, and
                making valuable contributions in new position.
              </li>
              <br />
              <li>
                Currently seeking a challenging industry role to enhance
                technical growth and fulfill career objectives.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
